import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MoveToInboxAddTicketSubject = ({
  subject,
  setSubject
}) => {
  const handleSubjectOnChange = useCallback(evt => setSubject(evt.target.value), [setSubject]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-4 m-bottom-4",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.moveToInboxPrompt.ticketSubjectTitle"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "move-to-helpdesk-subject-input",
      value: subject,
      onChange: handleSubjectOnChange
    })
  });
};
MoveToInboxAddTicketSubject.displayName = 'MoveToInboxAddTicketSubject';
export default MoveToInboxAddTicketSubject;